import React from 'react';
import { ReactComponent as SoccerIcon } from 'images/sports/menu/soccer.svg';
import { ReactComponent as BaseballIcon } from 'images/sports/menu/baseball.svg';
import { ReactComponent as BasketballIcon } from 'images/sports/menu/basketball.svg';
import { ReactComponent as VolleyballIcon } from 'images/sports/menu/volleyball.svg';
import { ReactComponent as IceHockeyIcon } from 'images/sports/menu/icehockey.svg';
import { ReactComponent as FootballIcon } from 'images/sports/menu/football.svg';
import { ReactComponent as LolIcon } from 'images/sports/menu/lol.svg';
import { ReactComponent as StarcraftIcon } from 'images/sports/menu/starcraft.svg';

const SportsTypeIcon = ({ sportsType, height, width }) => {
  if (sportsType === 'SOCCER') {
    return <SoccerIcon width={width} height={height} />;
  } else if (sportsType === 'BASEBALL') {
    return <BaseballIcon width={width} height={height} />;
  } else if (sportsType === 'BASKETBALL') {
    return <BasketballIcon width={width} height={height} />;
  } else if (sportsType === 'VOLLEYBALL') {
    return <VolleyballIcon width={width} height={height} />;
  } else if (sportsType === 'HOCKEY') {
    return <IceHockeyIcon width={width} height={height} />;
  } else if (sportsType === 'FOOTBALL') {
    return <FootballIcon width={width} height={height} />;
  } else if (sportsType === 'LOL') {
    return <LolIcon width={width} height={height} />;
  } else if (sportsType === 'STARCRAFT') {
    return <StarcraftIcon width={width} height={height} />;
  } else {
    return null;
  }
};

export default SportsTypeIcon;
